import { createSelector } from 'reselect'

export const getStoryLine = (state) => state.storyLine
export const getHOCs = createSelector(
  [getStoryLine],
  (storyLine) => {
    return {
      ...storyLine.hocs,
      sceneSwicher: {
        attributeName: 'nextScene',
        component: 'SceneSwitcher',
      },
    }
  }
)
export const getScenesWithDocuments = createSelector([getStoryLine], (storyline) => {
  return Object.keys(storyline.scenes)
    .map((sceneName) => storyline.scenes[sceneName])
    .filter((scene) => scene.hasDocuments)
})

export const getFederationsFlags = createSelector([getStoryLine], (storyline) => {
  return storyline.flags
})

export const getPopups = createSelector([getStoryLine], (storyline) => {
  return storyline.popups
})
/*
 * getItems -> get all objects from the storyline
 */
export const getItems = createSelector([getStoryLine], (repository) => {
  return {
    ...repository.collectorObjects,
    ...repository.extraObjects,
    ...repository.inventoryObjects,
    ...repository.sceneObjects,
  }
})

export const getSceneObjects = createSelector(
  [getStoryLine],
  (repository) => repository.sceneObjects
)
